import React from 'react'

const ChallengeSection = ({ content, mainHeading, description }) => {
    return (
        <div className="bussiness-chalanges-main-section">
            <div className="container">
                <div className="row">
                    <div className="col-xl-6">
                        <div className="bussiness-chalanges-section-conent">
                            <h4>{mainHeading}</h4>
                            <p className="description-text">{description}</p>
                        </div>
                    </div>

                    <div className="col-xl-6 col-lg-6 col-md-12">
                        {content?.map((item, index) => {
                            return <div className="bussiness-chalanges-content-box" key={index}>
                                <h4>{item?.title}</h4>
                                <p className="description-text">{item?.description}</p>
                            </div>
                        })}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ChallengeSection